import React from 'react';
import { SettingTermsAndConditionsContainer } from 'components';

function SettingTermsAndConditionsParentComponent(props) {
    return <SettingTermsAndConditionsContainer />;
}

export default SettingTermsAndConditionsParentComponent;
